export default "__VITE_ASSET__D$0pow8u__"